import React, { useEffect, useState } from 'react';
import List from 'devextreme-react/list';
import { useAuth } from '../../../contexts/auth';
import { getEmailPlaceholders } from '../../../api/emailTemplates';
import type { PlaceholderGroup } from '../../../types/email-template';
import './placeholder-panel.scss';

interface PlaceholderPanelProps {
  templateType?: string;
}

/**
 * Sidebar showing all available {{placeholders}} grouped by category.
 * Users can click to copy the merge tag to their clipboard,
 * then paste it into the Unlayer editor or the subject line field.
 */
const PlaceholderPanel: React.FC<PlaceholderPanelProps> = ({ templateType }) => {
  const { user } = useAuth();
  const [groups, setGroups] = useState<PlaceholderGroup[]>([]);

  useEffect(() => {
    (async() => {
      try {
        const data = await getEmailPlaceholders(user?.token, templateType);
        setGroups(data);
      } catch {
        setGroups([]);
      }
    })();
  }, [user?.token, templateType]);

  const copyToClipboard = (key: string) => {
    const tag = `{{${key}}}`;
    navigator.clipboard.writeText(tag);
  };

  return (
    <div className='placeholder-panel'>
      <h4>Samenvoegvelden</h4>
      <p className='hint'>Klik om te kopiëren, plak in het sjabloon.</p>
      {groups.map((group) => (
        <div key={group.Group} className='placeholder-group'>
          <div className='group-title'>{group.Group}</div>
          <List
            dataSource={group.Items}
            keyExpr='Key'
            displayExpr='Label'
            selectionMode='none'
            onItemClick={(e: any) => copyToClipboard(e.itemData.Key)}
            itemRender={(item: any) => (
              <div className='placeholder-item'>
                <span className='placeholder-label'>{item.Label}</span>
                <code className='placeholder-tag'>{`{{${item.Key}}}`}</code>
              </div>
            )}
          />
        </div>
      ))}
    </div>
  );
};

export { PlaceholderPanel };
